let genderArray;
let ridingPosition;
let terrain;
let rideFrequency;
let lengthRide;
let painArray = [];

let intialProduct = [];
let currentPage = 1;
let saddleFinderProduct = [];
let paginationLength;
class TemplateQuizJS {
    constructor() {
      const that = this;
     
      document.querySelectorAll('[data-quiz-gender]').forEach((element) => {
          element.addEventListener('change', () => {
              that._selectedGenderSaddle();
              this._checkInputs();
          });
      });
      
      document.querySelectorAll('[data-quiz-riding_positon]').forEach((element) => {
          element.addEventListener('change', () => {
              that._selectedRidingSaddle();
              this._checkInputs();          
          });
      });
      
      document.querySelectorAll('[data-quiz-terrain]').forEach((element) => {
          element.addEventListener('change', () => {
              that._selectedTerrainSaddle();
              this._checkInputs();          
          });
      });
      
      document.querySelectorAll('[data-quiz-ride_frequency]').forEach((element) => {
          element.addEventListener('change', () => {
              that._selectedRideFrequency();
              this._checkInputs();          
          });
      });
      
      document.querySelectorAll('[data-quiz-length_ride]').forEach((element) => {
          element.addEventListener('change', () => {
              that._selectedRideLength();
              this._checkInputs();         
          });
      });
      
      var allQuizPainInput = document.querySelectorAll('[data-quiz-pain]');
      allQuizPainInput.forEach((element) => {
          element.addEventListener('change', (e) => {
              e.preventDefault();
              var inputValue = e.target.value;
              if (inputValue == "ss_no-issues") {
                allQuizPainInput.forEach(item => item.value != "ss_no-issues" ? (item.checked = false) : "")
              } else {
                allQuizPainInput.forEach(item => item.value == "ss_no-issues" ? (item.checked = false) : "")
              }
              that._selectedPainSaddle();
              this._checkInputs();
          });
      });

      this._checkInputs();

      

      document.querySelector('[data-start-over]').addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelectorAll('[data-quiz-gender]').forEach(input => input.checked = false);
        document.querySelectorAll('[data-quiz-riding_positon]').forEach(input => input.checked = false);
        document.querySelectorAll('[data-quiz-terrain]').forEach(input => input.checked = false);
        document.querySelectorAll('[data-quiz-ride_frequency]').forEach(input => input.checked = false);
        document.querySelectorAll('[data-quiz-length_ride]').forEach(input => input.checked = false);
        document.querySelectorAll('[data-quiz-pain]').forEach(input => input.checked = false);
        genderArray = [];
        ridingPosition = null;
        terrain = null;
        rideFrequency = null;
        lengthRide = null;
        painArray = [];
        
        // Reset the count display
        document.querySelector('[data-active-selection]').textContent = '0';
        document.querySelector('[data-matched-items]').innerHTML = document.querySelectorAll('[data-intial-products] #product-grids [data-product-grid]')?.length || 0;
        document.querySelector('[data-totalProducts] a').classList.remove('text-gray-1000', 'bg-success-2')
        document.querySelector('[data-recommended-text] h3').classList.add('d-none');
        document.querySelector('[data-recommended-text]').classList.remove('recosub');
        document.querySelector('[data-intial-products]').classList.remove('d-none');
        document.querySelector('#saddle-scroll')?.classList.add('d-none');
        document.querySelector('[data-result-products]').innerHTML = '';

        document.querySelector('[data-no-result]').classList.add('d-none');



      });
    }

    _checkInputs() {
      let showResultBtn = document.querySelector('[data-show-result]');
      
      let genderSelected = document.querySelectorAll('[data-quiz-gender]:checked');
      let ridingPositionSelected = document.querySelectorAll('[data-quiz-riding_positon]:checked');
      let terrainSelected = document.querySelectorAll('[data-quiz-terrain]:checked');
      let rideFrequencySelected = document.querySelectorAll('[data-quiz-ride_frequency]:checked');
      let rideLengthSelected = document.querySelectorAll('[data-quiz-length_ride]:checked');
      let painSelected = document.querySelectorAll('[data-quiz-pain]:checked');
  
      let selectedGroupCount = 0;

      // Check if any option is selected for each category and increment count
      if (genderSelected.length > 0) selectedGroupCount++;
      if (ridingPositionSelected.length > 0) selectedGroupCount++;
      if (terrainSelected.length > 0) selectedGroupCount++;
      if (rideFrequencySelected.length > 0) selectedGroupCount++;
      if (rideLengthSelected.length > 0) selectedGroupCount++;
      if (painSelected.length > 0) selectedGroupCount++;
  
      // Display the total count of selected groups
      document.querySelector('[data-active-selection]').textContent = selectedGroupCount;

      // Check if any option is selected for each category
      if (genderSelected.length > 0 ||
          ridingPositionSelected.length > 0 ||
          terrainSelected.length > 0 ||
          rideFrequencySelected.length > 0 ||
          rideLengthSelected.length > 0 ||
          painSelected.length > 0) {
          this._showResult();
      } 
    }
  


    
    _selectedGenderSaddle() {
     
      genderArray = [];
      document.querySelectorAll('[data-quiz-gender]:checked').forEach(target => {
        let tagValue = target.value;
        if (tagValue) {
          genderArray.push(tagValue);
        }
      });
       
    }

    _selectedRidingSaddle() {
      document.querySelectorAll('[data-quiz-riding_positon]:checked').forEach(target => {
        let tagValue = target.value;
        if (tagValue) {
          ridingPosition = tagValue;
        }
      });
    }

    _selectedTerrainSaddle(){
      document.querySelectorAll('[data-quiz-terrain]:checked').forEach(target => {
        let tagValue = target.value;
        if (tagValue) {
          terrain = tagValue;
        }
      });
    }

    _selectedRideFrequency(){
      document.querySelectorAll('[data-quiz-ride_frequency]:checked').forEach(target => {
        let tagValue = target.value;
        if (tagValue) {
          lengthRide = tagValue;
        }
      });
    }

    _selectedRideLength(){
      document.querySelectorAll('[data-quiz-length_ride]:checked').forEach(target => {
        let tagValue = target.value;
        if (tagValue) {
          rideFrequency = tagValue;
        }
      });
    }

    _selectedPainSaddle() {
     
      painArray = [];
      document.querySelectorAll('[data-quiz-pain]:checked').forEach(target => {
        let tagValue = target.value;
        if (tagValue) {
          painArray.push(tagValue);
        }
      });
       
    }

  
    _htmlPrepare(saddleFinderProduct) {
      let allHTML = '';
      let base64 = saddleFinderProduct.node.id;
      var getLastPart = base64.split('/'); //if need to decode this just replace base64 into decodeBase64
      var pID = getLastPart[getLastPart.length-1];
      intialProduct.push(saddleFinderProduct);

      let allTags = '';
      let imageGroup = '';
      let priceHTML = '';
      let productDetails = '';

      saddleFinderProduct.node.tags.forEach(function(tag) {
        if (tag.indexOf('Featured Hotel:') > 1) {
          allTags += `<span class="badge badge-right badge-warning text-regal_blue-400 text-uppercase mr-2 mb-2">${tag.replace('Featured Hotel:','').replace('-',' ')}</span>`;
        }
        if (tag.indexOf('Featured Hotel Hidden:') > 1) {
          allTags += `<span class="badge badge-right badge-warning text-regal_blue-400 text-uppercase mr-2 mb-2">${tag.replace('Featured Hotel Hidden:','').replace('-',' ')}</span>`;
        }
        if (tag.indexOf('discount_percentage-') > 1) {
          allTags += `<span class="badge badge-right badge-warning text-regal_blue-400 text-uppercase mr-2 mb-2">${tag.replace('discount_percentage-','').replace('-',' ')}</span>`;
        }
        if (tag.indexOf('OUT_OF-STOCK') > 1) {
          allTags += `<span class="badge badge-right badge-warning text-regal_blue-400 text-uppercase mr-2 mb-2">${tag.replace('-','').replace('-',' ')}</span>`;
        }
        if (tag.indexOf('BACK_IN-STOCK') > 1) {
          allTags += `<span class="badge badge-right badge-warning text-regal_blue-400 text-uppercase mr-2 mb-2">${tag.replace('-','').replace('-',' ')}</span>`;
        }
        if (tag.indexOf('MOST-POPULAR') > 1) {
          allTags += `<span class="badge badge-right badge-warning text-regal_blue-400 text-uppercase mr-2 mb-2">${tag.replace('-','').replace('-',' ')}</span>`;
        }
      });

      saddleFinderProduct.node.metafields.forEach((meta) => {
        if (meta) {
          if(meta.key == 'saddle_length_width'){
            productDetails += `<div class="extra-grids lh-1">
              <strong class="text-capitalize fw-semibold">Length/Width:</strong> <span>${meta.value}</span>
            </div>`
          } else if(meta.key == 'saddle_weight'){
            productDetails += `<div class="extra-grids lh-1">
              <strong class="text-capitalize fw-semibold">Weight:</strong> <span>${meta.value}</span>
            </div>`
          } else if(meta.key == 'saddle_rails'){
            productDetails += `<div class="extra-grids lh-1">
              <strong class="text-capitalize fw-semibold">Rails:</strong> <span>${meta.value}</span>
            </div>`
          } else if(meta.key == 'saddle_cover'){
            productDetails += `<div class="extra-grids lh-1">
              <strong class="text-capitalize fw-semibold">Cover:</strong> <span>${meta.value}</span>
            </div>`
          }
        }
      })
      let image = saddleFinderProduct.node.selectedOrFirstAvailableVariant?.image?.url || saddleFinderProduct.node.media.edges[0].node.image.url
      if (saddleFinderProduct.node.media.edges.length == 1 && saddleFinderProduct.node.media.edges[0]) {
        imageGroup += `<img src="${image.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png')}" 
                            data-src="${image.replace('.jpg', '_380x.jpg').replace('.png', '_380x.png')}"
                            alt="${saddleFinderProduct.node.title}" 
                            loading="lazy"
                            class="img-fluid transition">`;
      } else if (saddleFinderProduct.node.media.edges.length > 1 && saddleFinderProduct.node.media.edges[1]) {
        imageGroup += `<img src="${image.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png')}" 
                            data-src="${image.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png')}"
                            alt="${saddleFinderProduct.node.title}" 
                            loading="lazy"
                            class="img-fluid transition">`;
        imageGroup += `<img src="${saddleFinderProduct.node.media.edges[1].node.image.url.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png')}"
                            data-src="${saddleFinderProduct.node.media.edges[1].node.image.url.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png')}" 
                            alt="${saddleFinderProduct.node.title}"
                            loading="lazy"
                            class="img-fluid transition">`
      } else {
        imageGroup += `<img src="terrycycling.com/cdn/shop/files/logo.svg?v=1725002216" 
                            alt="${saddleFinderProduct.node.title}"
                            loading="lazy" 
                            class="img-fluid transition">`;
      }

   
      priceHTML += `<span class="price m-0 p-0">$${parseFloat(saddleFinderProduct.node.selectedOrFirstAvailableVariant.price.amount).toFixed(2)}</span>`;
      
      allHTML += `<div class="col-lg-4 col-md-4 col-sm-6 mb-5 d-flex align-items-stretch justify-content-around saddle-coll-grid">
                    <div class="card card-product position-relative" data-product-grid>
                      <div class="card-inner w-100 flex-column d-flex flex-grow-1">
                          <div class="card-img w-100 position-relative ">
                            <span class="badges">
                              <span class="badge badge-new">${allTags}</span>
                            </span>
                            <a href="/products/${saddleFinderProduct.node.handle}" class="prod-img d-block product-link position-relative">
                              ${imageGroup}  
                            </a>
                            <div class="row main-cta-btns start-0 end-0 bottom-0 mx-auto position-absolute d-none">
                              <div class="col-12 d-flex justify-content-center">
                                <a href="#" rel="nofollow" class="btn btn-light btn-sm quickshop--button" data-quick-shop data-handle="${saddleFinderProduct.node.handle}" title="{{ 'products.product.quickshop' | t | escape }}" aria-label="{{ 'products.product.quickshop' | t | escape }}" data-toggle="tooltip" data-trigger="hover" data-placement="top">
                                  Quick View
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="card-body w-100 px-0 pb-2 mb-1 text-center">
                            <a class="product-link color-inherit d-block mb-0 fw-bold" href="/products/${saddleFinderProduct.node.handle}">${saddleFinderProduct.node.title}</a>
                            <div class="text-left" data-all-filter-selected>
                              ${priceHTML}
                            </div>
                            <div class="extra_information mb-md-4 mb-3 mt-2 d-flex flex-column align-items-center" data-all-filter-selected>
                              ${productDetails}
                            </div>
                            <div class="saddle-details" data-all-filter-selected>
                              <a class="btn btn-primary btn-sm" href="/products/${saddleFinderProduct.node.handle}">Details ></a>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>`;
      return allHTML;
    }

    _htmlPrepareForPagination(paginationLength, currentPage) {
      let paginationHTML = '';
      let paginationNumbers = '';
      currentPage = parseInt(currentPage);
      for (var j = 0; j < paginationLength; j++) {
        paginationNumbers += `<li class="page-item">
                                <a class="${currentPage == (j + 1) ? 'bg-alice_blue' : ''} page-link align-items-center d-flex justify-content-center page-link" 
                                    href="javascript:void(0)" 
                                    data-current-page="${j+1}" data-pagination="${j+1}">${j+1} 
                                </a>
                              </li>`;
      }
      
      paginationHTML += `<ul class="pagination">
                              ${currentPage != 1 ? `<li class="page-item">
                                                      <a class="page-link" href="javascript:void(0)" 
                                                          data-first-page="${currentPage-1}" data-pagination="${currentPage-1}">
                                                          <span class="d-block text-nowrap text-uppercase font-weight-bold px-2">Prev</span>
                                                      </a>
                                                    </li>` : ''}
                              ${paginationNumbers}
                              <li class="page-item">
                                <a class="page-link" 
                                    href="javascript:void(0)" 
                                    data-last-page="${currentPage+1}" data-pagination="${currentPage+1}">
                                  <span class="d-block text-nowrap text-uppercase font-weight-bold px-2">Next</span>
                                </a>
                              </li>
                            </ul>`;

      if(paginationLength > 1){
        document.querySelector('[data-page-number]').innerHTML = paginationHTML;
        // document.querySelector('[data-page-number]').classList.remove('d-none');
        
        document.querySelectorAll('[data-pagination]').forEach((element) => {
          element.addEventListener('click', (event) => this._nextPageProduct(event, element.getAttribute('data-pagination')));
        });
      }
    }

    _showResult() {
        currentPage = 1;

        var genderStr = '';
        genderArray?.forEach((sleep, i) => {
          if (i == genderArray.length - 1) {
            genderStr = genderStr + `tag:'${sleep}'`
          } else if (genderArray.length > 1) {
            genderStr = genderStr + `tag:'${sleep}' AND `
          } else {
            genderStr = genderStr + `tag:'${sleep}'`
          }
        });

        var painStr = '';
        painArray?.forEach((sleep, i) => {
          if(sleep != "ss_no-issues"){
            if (i == painArray.length - 1) {
              painStr = painStr + `tag:'${sleep}'`
            } else if (painArray.length > 1) {
              painStr = painStr + `tag:'${sleep}' AND `
            } else {
              painStr = painStr + `tag:'${sleep}'`
            }
          } else {
            painStr = "ss_no-issues";
          }
        });

        // Build query parts array to avoid empty conditions
        let queryParts = [];
        
        if (genderStr && genderStr.length > 0) {
          queryParts.push(`(${genderStr})`);
        }
        if (ridingPosition && ridingPosition.length > 0) {
          queryParts.push(`(tag:'${ridingPosition}')`);
        }
        if (terrain && terrain.length > 0) {
          queryParts.push(`(tag:'${terrain}')`);
        }
        if (rideFrequency && rideFrequency.length > 0) {
          queryParts.push(`(tag:'${rideFrequency}')`);
        }
        if (lengthRide && lengthRide.length > 0) {
          queryParts.push(`(tag:'${lengthRide}')`);
        }
        if (painStr && painStr.length > 0 && painStr != "ss_no-issues") {
          queryParts.push(`(${painStr})`);
        }
        
        // Add product type filter
        queryParts.push(`(product_type:'Saddles: Men' OR product_type:'Saddles: Women')`);
        
        // Join all parts with AND
        let QueryParamerer = queryParts.join(' AND ');
        console.log(QueryParamerer,'QueryParamerer')
        const productQuery = {
          query: `{
            products(first: 250, query: "${QueryParamerer}"){
              edges {
                node {
                  id
                  title
                  handle
                  priceRange {
                    minVariantPrice {
                      amount
                    }
                  }
                  selectedOrFirstAvailableVariant {
                    price {
                      amount
                    }
                    image {
                      url
                    }
                  }
                  media(first: 2) {
                    edges {
                      node {
                        ... on MediaImage {
                          id
                          image {
                            altText
                            url
                          }
                        }
                      }
                    }
                  }
                  metafields(
                    identifiers: 
                    [
                      {namespace: "saddle", key: "saddle_length_width"},
                      {namespace: "saddle", key: "saddle_weight"},
                      {namespace: "saddle", key: "saddle_rails"},
                      {namespace: "saddle", key: "saddle_cover"}
                    ]
                    ) {
                    value
                    key
                  }
                  tags
                }
              }
            }
          }`
        }

        const config = {
          method: 'POST',
          url: '/api/2024-10/graphql.json',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Origin': '*',
            'X-Shopify-Storefront-Access-Token': "e700abd98382b6dbae4c346d21ccc43f"
          },
          data: productQuery,
        }
  
        fetch(config.url, {
            method: config.method,
            headers: config.headers,
            body: JSON.stringify(config.data)
        }).then(response => response.json())
          .then(data => {

            saddleFinderProduct = data.data.products.edges;
            paginationLength = Math.ceil(saddleFinderProduct.length / 30);
            
            if (saddleFinderProduct.length > 0) {  
              let htmlData = '';
              for (var i = 0; i < saddleFinderProduct.length; i++) {
                if (saddleFinderProduct[i] !== undefined) {
                  htmlData += this._htmlPrepare(saddleFinderProduct[i]);
                }
              }
              document.querySelector('[data-result-products]').innerHTML = `
                <div class="row justify-content-evenly" id="product-grids">
                ${htmlData}
                </div>
              `;

              var allFilterSelected;
              if (genderStr.length > 0 && ridingPosition && terrain && rideFrequency && lengthRide && (painStr || painStr == "ss_no-issues")) {
                allFilterSelected = true;
                document.querySelector('[data-result-products]')?.classList.add('saddle-selected-items', 'all-filter-selected');
                document.querySelector('#saddle-scroll')?.classList.remove('d-none');
                document.querySelector('[data-recommended-text] h3')?.classList.remove('d-none');
              } else {
                allFilterSelected = false;
                document.querySelector('[data-result-products]')?.classList.remove('saddle-selected-items', 'all-filter-selected');
                document.querySelector('#saddle-scroll')?.classList.add('d-none');
                document.querySelector('[data-recommended-text] h3')?.classList.add('d-none');
              }
              
              document.querySelector('[data-matched-items]').innerHTML = saddleFinderProduct.length;
              document.querySelector('[data-totalProducts] a').classList.add('text-gray-1000', 'bg-success-2')
              document.querySelector('[data-recommended-text]').classList.add('recosub');
              document.querySelector('[data-intial-products]').classList.add('d-none');
              document.querySelector('[data-no-result]').classList.add('d-none');

              this._htmlPrepareForPagination(paginationLength, currentPage);
  
              this.quickViewBind()
              // setTimeout(function() {
              //   StampedFn.reloadUGC();
              // }, 100);
            } else {
              document.querySelector('[data-intial-products]').classList.add('d-none');
              document.querySelector('[data-result-products]').innerHTML = '';
              document.querySelector('[data-matched-items]').innerHTML = saddleFinderProduct.length;
              document.querySelector('[data-no-result]').classList.remove('d-none');
            }
            
            //this._scrollTop();
            //document.querySelector('[data-loader]').classList.add('d-none');
          })
          .catch(error => console.error('Error:', error));
    }
   quickViewBind(){
      quickShop.prototype.bindEvents();
    }

    _scrollTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
}
typeof TemplateQuizJS !== 'undefined' && new TemplateQuizJS();


if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
  setTimeout(() => {
    document.querySelector('[data-start-over]')?.click();
  }, 1000);
}